import { Sparkle, DottedArc } from "./Decorations";

const CARDS = [
  {
    word: "Run",
    sub: "Cardio that protects joints and the heart",
    img: "/images/fitness-3.webp",
    alt: "Dr. Maggie running outdoors for cardiovascular and joint health",
    pos: "object-top",
  },
  {
    word: "Stretch",
    sub: "Mobility and flexibility for the long run",
    img: "/images/fitness-2.webp",
    alt: "Outdoor stretching for joint mobility and flexibility",
  },
  {
    word: "Reflect",
    sub: "Rest, recover, return ready",
    img: "/images/about-portrait.webp",
    alt: "Dr. Maggie in a yoga warrior pose with arms raised, symbolizing recovery, reflection, and readiness",
  },
];

export default function FitnessCorner() {
  return (
    <section
      id="fitness-corner"
      data-testid="fitness-corner-section"
      className="relative py-28 bg-gradient-to-b from-white via-lavender-bg/50 to-white overflow-hidden"
    >
      <Sparkle className="absolute top-20 left-10" color="#C7A5D9" size={22} />
      <Sparkle className="absolute bottom-24 right-12" color="#8E44AD" size={16} />
      <DottedArc className="absolute -top-4 left-1/2 -translate-x-1/2 w-72 opacity-50" color="#C7A5D9" />

      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <p className="pill mb-5 reveal">Lifestyle</p>
          <h2
            className="h-display text-3xl sm:text-4xl title-underline reveal"
            data-testid="fitness-corner-title"
          >
            Dr. Maggie's Fitness Corner
          </h2>
          <p className="mt-7 text-charcoal/75 reveal-blur">
            Three movement practices that shape a balanced life beyond the clinic.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-7">
          {CARDS.map((c, i) => (
            <article
              key={c.word}
              data-testid={`fitness-card-${i}`}
              className={`${i % 2 === 0 ? "reveal-left" : "reveal-right"} card-soft overflow-hidden group glow-accent`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="zoom-wrap rounded-none relative">
                <img
                  src={c.img}
                  alt={c.alt}
                  loading="lazy"
                  className={`w-full h-72 object-cover ${c.pos || "object-center"}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-plum/55 via-plum/15 to-transparent transition-opacity duration-500 group-hover:opacity-80" />
                <span className="absolute top-4 right-4 h-9 w-9 rounded-full bg-white/85 backdrop-blur grid place-items-center text-royal text-[11px] font-display tracking-widest">
                  0{i + 1}
                </span>
              </div>
              <div className="p-7 text-center">
                <h3 className="h-display text-xl re-underline reveal">{c.word}</h3>
                <p className="mt-4 text-[15px] text-charcoal/75 leading-relaxed">{c.sub}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
